import style from "./style.scss";

import { mergeClasses } from "../helpers";

const ButtonDualGroup = ({
  class: className = null,
  small = false,
  children,
  ...props
}) => {
  const mergedClass = mergeClasses([
    small ? style.buttonOutlineGroup : style.buttonOutlineGroupSimple,
    className,
  ]);

  return (
    <div class={mergedClass} {...props}>
      {children}
    </div>
  );
};

export default ButtonDualGroup;
